import React, { Fragment, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import HeaderEjercicios from '../../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../../Escritorio/Instrucciones';

import useConfigAuth from '../../../../Hooks/useConfigAuth';

import BotoneraBottom from '../../Compartidos/BotoneraBottom';

import {
    finalizarEjercicioAction,
    setearEjercicioAction,
    setearUrlAnteriorAction
} from '../../../../actions/estadoEjercicioActions';

import { almacenarAction } from '../../../../actions/almacenarEjercicioActions';

import {
    AvanzarImg,
    AvanzarBtn,
    PantallaM153,
    ContenidoM153,
    EnunciadoM153,
    ZonaCentralM153,
    PanelIzquierdoM153,
    PanelDerechoM153,
    EscenaM153,
    RespuestaM153,
    BottomM153
} from '../../../Css/StyledMatematica';


// ============================================================================
// CONFIGURACIÓN
// ============================================================================

const CANTIDAD_EJERCICIOS = 5;

const MAX_PARTES = 12;

const ACCENT = '#23AAAF';
const MARK = '#E8662B';
const OK = '#2E8B57';
const INK = '#222';
const PINTADO = '#F2A541';

const miniInstrucciones =
    'Leé el problema, representá la situación y escribí la respuesta.';


// ============================================================================
// BANCO DE EJERCICIOS
// ============================================================================

const EJERCICIOS = [

    // ------------------------------------------------------------------------
    // PIZZA
    // ------------------------------------------------------------------------

    {
        id: 'pizza-1',
        tipo: 'pizza',
        partes: 8,
        sacar: 6,
        mide: 'queda',
        lineas: [
            'Invité amigos a comer a casa.',
            'Pedimos 1 pizza.',
            'La partimos en 8 porciones iguales.',
            'Se comieron 6 porciones.',
            '¿Cuánta pizza quedó?'
        ],
        instruccion:
            'Tocá las porciones que se comieron.'
    },

    {
        id: 'pizza-2',
        tipo: 'pizza',
        enteros: 2,
        partes: 4,
        sacar: 3,
        mide: 'queda',
        lineas: [
            'Para la cena compramos 2 pizzas.',
            'Cortamos cada pizza en 4 porciones iguales.',
            'Papá se comió 2 porciones.',
            'Yo me comí 1 porción.',
            '¿Cuánta pizza quedó?'
        ],
        instruccion:
            'Tocá las porciones que se comieron papá y yo.'
    },

    {
        id: 'pizza-3',
        tipo: 'pizza',
        enteros: 4,
        partes: 4,
        sacar: 3,
        mide: 'queda',
        lineas: [
            'Hicimos una fiesta en el club.',
            'Compramos 4 pizzas.',
            'Cortamos cada una en 4 porciones iguales.',
            'Se comieron 3 porciones.',
            '¿Cuánta pizza sobró?'
        ],
        instruccion:
            'Tocá las porciones que se comieron.'
    },

    {
        id: 'pizza-4',
        tipo: 'pizza',
        partes: 6,
        sacar: 2,
        mide: 'sacado',
        lineas: [
            'El domingo hicimos pizza casera.',
            'La cortamos en 6 porciones iguales.',
            'Mi hermano se comió 2 porciones.',
            '¿Qué parte de la pizza se comió mi hermano?'
        ],
        instruccion:
            'Tocá las porciones que se comió mi hermano.'
    },

    {
        id: 'pizza-5',
        tipo: 'pizza',
        enteros: 2,
        partes: 8,
        sacar: 12,
        mide: 'queda',
        lineas: [
            'Vinieron mis primos a casa.',
            'Pedimos 2 pizzas.',
            'Cortamos cada pizza en 8 porciones iguales.',
            'Entre todos comimos 12 porciones.',
            '¿Cuánta pizza quedó?'
        ],
        instruccion:
            'Tocá las porciones que comimos.'
    },

    {
        id: 'pizza-6',
        tipo: 'pizza',
        enteros: 3,
        partes: 6,
        sacar: 9,
        mide: 'sacado',
        lineas: [
            'Festejamos el cumple de la abuela.',
            'Había 3 pizzas.',
            'Cortamos cada pizza en 6 porciones iguales.',
            'Los chicos se comieron 9 porciones.',
            '¿Cuánta pizza comieron los chicos?'
        ],
        instruccion:
            'Tocá las porciones que se comieron los chicos.'
    },


    // ------------------------------------------------------------------------
    // HELADO
    // ------------------------------------------------------------------------

    {
        id: 'helado-1',
        tipo: 'helado',
        partes: 4,
        sacar: 3,
        mide: 'queda',
        lineas: [
            'Compramos 1 kilo de helado.',
            'Pedimos 4 gustos.',
            'Cada gusto tiene la misma cantidad.',
            'En casa somos 4.',
            'Tres comimos un gusto cada uno.',
            'Mi hermano no quiso helado.',
            '¿Qué parte del kilo quedó?'
        ],
        instruccion:
            'Tocá los gustos que se comieron.'
    },

    {
        id: 'helado-2',
        tipo: 'helado',
        partes: 3,
        sacar: 1,
        mide: 'queda',
        lineas: [
            'Después de cenar compramos 1 kilo de helado.',
            'Pedimos 3 gustos.',
            'Cada gusto tiene la misma cantidad.',
            'Nos comimos todo el gusto de chocolate.',
            '¿Qué parte del kilo quedó?'
        ],
        instruccion:
            'Tocá el gusto que nos comimos.'
    },

    {
        id: 'helado-3',
        tipo: 'helado',
        enteros: 2,
        partes: 4,
        sacar: 5,
        mide: 'queda',
        lineas: [
            'Para el cumple compramos 2 kilos de helado.',
            'Cada kilo tiene 4 gustos.',
            'Todos los gustos tienen la misma cantidad.',
            'Los invitados se comieron 5 gustos.',
            '¿Cuánto helado quedó?'
        ],
        instruccion:
            'Tocá los gustos que se comieron los invitados.'
    },

    {
        id: 'helado-4',
        tipo: 'helado',
        enteros: 2,
        partes: 2,
        sacar: 1,
        mide: 'queda',
        lineas: [
            'Compramos 2 kilos de helado.',
            'Cada kilo tiene 2 gustos, mitad y mitad.',
            'El sábado nos comimos un gusto entero.',
            '¿Cuánto helado nos queda?'
        ],
        instruccion:
            'Tocá el gusto que nos comimos.'
    },


    // ------------------------------------------------------------------------
    // CHOCOLATE
    // ------------------------------------------------------------------------

    {
        id: 'chocolate-1',
        tipo: 'chocolate',
        partes: 6,
        sacar: 3,
        mide: 'queda',
        lineas: [
            'Mi abuela me regaló un chocolate.',
            'Lo partí en 6 partes iguales.',
            'Le di 2 partes a mi hermano.',
            'Yo me comí 1 parte.',
            '¿Qué parte del chocolate quedó?'
        ],
        instruccion:
            'Tocá las partes que le di a mi hermano y la que me comí.'
    },

    {
        id: 'chocolate-2',
        tipo: 'chocolate',
        partes: 4,
        sacar: 1,
        mide: 'sacado',
        lineas: [
            'Tengo un chocolate.',
            'Lo parto en 4 partes iguales.',
            'Le convido 1 parte a mi amiga Lula.',
            '¿Qué parte del chocolate le di a Lula?'
        ],
        instruccion:
            'Tocá la parte que le di a Lula.'
    },

    {
        id: 'chocolate-3',
        tipo: 'chocolate',
        enteros: 3,
        partes: 2,
        sacar: 1,
        mide: 'queda',
        lineas: [
            'En la mochila tengo 3 chocolates.',
            'Parto cada chocolate en 2 mitades.',
            'En el recreo me como 1 mitad.',
            '¿Cuánto chocolate me queda?'
        ],
        instruccion:
            'Tocá la mitad que me comí.'
    },

    {
        id: 'chocolate-4',
        tipo: 'chocolate',
        enteros: 2,
        partes: 5,
        sacar: 7,
        mide: 'queda',
        lineas: [
            'Mamá compró 2 chocolates.',
            'Partimos cada chocolate en 5 partes iguales.',
            'Mis hermanos y yo comimos 7 partes.',
            '¿Cuánto chocolate quedó?'
        ],
        instruccion:
            'Tocá las partes que comimos.'
    },


    // ------------------------------------------------------------------------
    // BOTELLAS
    // ------------------------------------------------------------------------

    {
        id: 'botella-1',
        tipo: 'botella',
        bebida: 'jugo',
        partes: 4,
        sacar: 3,
        mide: 'queda',
        lineas: [
            'Compramos una botella de jugo.',
            'Con la botella se llenan 4 vasos.',
            'Tomamos 3 vasos.',
            '¿Cuánto jugo queda en la botella?'
        ],
        instruccion:
            'Tocá la botella para sacar los vasos que tomamos.'
    },

    {
        id: 'botella-2',
        tipo: 'botella',
        bebida: 'gaseosa',
        enteros: 2,
        partes: 4,
        sacar: 3,
        mide: 'queda',
        lineas: [
            'Para la merienda hay 2 botellas de gaseosa.',
            'Con cada botella se llenan 4 vasos.',
            'Tomamos 3 vasos.',
            '¿Cuánta gaseosa queda?'
        ],
        instruccion:
            'Tocá las botellas para sacar los vasos que tomamos.'
    },

    {
        id: 'botella-3',
        tipo: 'botella',
        bebida: 'agua',
        partes: 6,
        sacar: 2,
        mide: 'sacado',
        lineas: [
            'Tengo una botella de agua.',
            'Con la botella lleno 6 vasos.',
            'Antes de entrenar tomo 2 vasos.',
            '¿Qué parte de la botella tomé?'
        ],
        instruccion:
            'Tocá la botella para sacar los vasos que tomé.'
    },

    {
        id: 'botella-4',
        tipo: 'botella',
        bebida: 'agua',
        enteros: 3,
        partes: 2,
        sacar: 1,
        mide: 'queda',
        lineas: [
            'Llevamos 3 botellas de agua a la plaza.',
            'Con cada botella se llenan 2 vasos.',
            'Tomamos 1 vaso.',
            '¿Cuántas botellas de agua quedan?'
        ],
        instruccion:
            'Tocá una botella para sacar el vaso que tomamos.'
    },


    // ------------------------------------------------------------------------
    // HUEVOS
    // ------------------------------------------------------------------------

    {
        id: 'huevos-1',
        tipo: 'huevos',
        sacar: 6,
        mide: 'sacado',
        lineas: [
            'Mamá compró una docena de huevos.',
            'Hizo una torta.',
            'Para la torta usó 6 huevos.',
            '¿Qué parte de la docena usó?'
        ],
        instruccion:
            'Tocá los huevos que usó.'
    },

    {
        id: 'huevos-2',
        tipo: 'huevos',
        sacar: 3,
        mide: 'queda',
        lineas: [
            'La abuela tenía una docena de huevos.',
            'Hizo un flan con 3 huevos.',
            '¿Qué parte de la docena le queda?'
        ],
        instruccion:
            'Tocá los huevos que usó.'
    },

    {
        id: 'huevos-3',
        tipo: 'huevos',
        enteros: 2,
        sacar: 6,
        mide: 'queda',
        lineas: [
            'Compramos 2 docenas de huevos.',
            'Para el cumple hicimos una torta.',
            'Usamos 6 huevos.',
            '¿Cuántas docenas nos quedan?'
        ],
        instruccion:
            'Tocá los huevos que usamos.'
    },


    // ------------------------------------------------------------------------
    // BATERÍA
    // ------------------------------------------------------------------------

    {
        id: 'bateria-1',
        tipo: 'bateria',
        partes: 5,
        sacar: 3,
        mide: 'queda',
        lineas: [
            'Cargué mi celular hasta llenar la batería.',
            'La batería tiene 5 rayitas.',
            'Jugué un rato.',
            'Se gastaron 3 rayitas.',
            '¿Cuánta batería le queda?'
        ],
        instruccion:
            'Tocá la batería para gastar las rayitas.'
    },

    {
        id: 'bateria-2',
        tipo: 'bateria',
        partes: 4,
        sacar: 1,
        mide: 'sacado',
        lineas: [
            'La batería de la tablet estaba llena.',
            'Tiene 4 rayitas.',
            'Mirando dibujitos se gastó 1 rayita.',
            '¿Qué parte de la batería se gastó?'
        ],
        instruccion:
            'Tocá la batería para gastar la rayita.'
    },

    {
        id: 'bateria-3',
        tipo: 'bateria',
        partes: 10,
        sacar: 7,
        mide: 'queda',
        lineas: [
            'El celular de mamá tiene la batería llena.',
            'La batería tiene 10 rayitas.',
            'Mamá usó el mapa para manejar.',
            'Se gastaron 7 rayitas.',
            '¿Cuánta batería le queda?'
        ],
        instruccion:
            'Tocá la batería para gastar las rayitas.'
    },


    // ------------------------------------------------------------------------
    // RUTA
    // ------------------------------------------------------------------------

    {
        id: 'ruta-1',
        tipo: 'ruta',
        destino: 'montaña',
        partes: 3,
        sacar: null,
        mide: 'uno',
        lineas: [
            'Me voy de viaje a la montaña.',
            'Viajo con mi amiga Lula y mi amigo Pepo.',
            'Los 3 vamos a manejar.',
            'Cada uno maneja una parte igual del camino.',
            '¿Qué parte del camino maneja cada uno?'
        ]
    },

    {
        id: 'ruta-2',
        tipo: 'ruta',
        destino: 'playa',
        partes: 4,
        sacar: 3,
        mide: 'queda',
        lineas: [
            'Vamos de vacaciones a la playa.',
            'El camino tiene 4 tramos iguales.',
            'Ya hicimos 3 tramos.',
            '¿Qué parte del camino nos falta?'
        ],
        instruccion:
            'Pintá los tramos que ya hicimos.'
    },

    {
        id: 'ruta-3',
        tipo: 'ruta',
        destino: 'playa',
        partes: 5,
        sacar: 2,
        mide: 'queda',
        lineas: [
            'Lula y Pepo van a la playa.',
            'El camino tiene 5 tramos iguales.',
            'Lula maneja 2 tramos.',
            'Pepo maneja el resto.',
            '¿Qué parte del camino maneja Pepo?'
        ],
        instruccion:
            'Pintá los tramos que maneja Lula.'
    },

    {
        id: 'ruta-4',
        tipo: 'ruta',
        destino: 'abuela',
        partes: 2,
        sacar: 1,
        mide: 'sacado',
        lineas: [
            'Vamos a la casa de la abuela.',
            'El camino tiene 2 tramos iguales.',
            'Paramos a comer al terminar el primer tramo.',
            '¿Qué parte del camino hicimos hasta la parada?'
        ],
        instruccion:
            'Pintá el camino hasta la parada.'
    },

    {
        id: 'ruta-5',
        tipo: 'ruta',
        destino: 'montaña',
        partes: 6,
        sacar: 4,
        mide: 'sacado',
        lineas: [
            'Viajamos a las sierras.',
            'El camino tiene 6 tramos iguales.',
            'Ya hicimos 4 tramos.',
            '¿Qué parte del camino ya hicimos?'
        ],
        instruccion:
            'Pintá los tramos que ya hicimos.'
    },

    {
        id: 'ruta-6',
        tipo: 'ruta',
        destino: 'playa',
        partes: 4,
        sacar: null,
        mide: 'uno',
        lineas: [
            'Nos vamos de vacaciones a la playa.',
            'Manejan papá, mamá, mi tía y mi tío.',
            'Cada uno maneja una parte igual del camino.',
            '¿Qué parte del camino maneja cada uno?'
        ]
    }

];


// ============================================================================
// DATOS POR TIPO
// ============================================================================

const DIVISIBLES = [
    'pizza',
    'helado',
    'chocolate',
    'botella',
    'ruta'
];


const TIPO = {

    pizza: {
        cosa: [
            'la pizza',
            'cada pizza'
        ],
        unidad: [
            'porción',
            'porciones'
        ],
        art: [
            'las',
            'esas'
        ]
    },

    helado: {
        cosa: [
            'el kilo',
            'cada kilo'
        ],
        unidad: [
            'gusto',
            'gustos'
        ],
        art: [
            'los',
            'esos'
        ]
    },

    chocolate: {
        cosa: [
            'el chocolate',
            'cada chocolate'
        ],
        unidad: [
            'parte',
            'partes'
        ],
        art: [
            'las',
            'esas'
        ]
    },

    botella: {
        cosa: [
            'la botella',
            'cada botella'
        ],
        unidad: [
            'vaso',
            'vasos'
        ],
        art: [
            'los',
            'esos'
        ]
    },

    huevos: {
        cosa: [
            'la docena',
            'cada docena'
        ],
        unidad: [
            'huevo',
            'huevos'
        ],
        art: [
            'los',
            'esos'
        ]
    },

    bateria: {
        cosa: [
            'la batería',
            'la batería'
        ],
        unidad: [
            'rayita',
            'rayitas'
        ],
        art: [
            'las',
            'esas'
        ]
    },

    ruta: {
        cosa: [
            'el camino',
            'el camino'
        ],
        unidad: [
            'tramo',
            'tramos'
        ],
        art: [
            'los',
            'esos'
        ]
    }

};


const PISTA_DEN = {

    pizza:
        '¿En cuántas porciones partiste cada pizza?',

    helado:
        '¿En cuántos gustos está partido cada kilo?',

    chocolate:
        '¿En cuántas partes partiste cada chocolate?',

    botella:
        '¿Cuántos vasos se llenan con cada botella?',

    huevos:
        '¿Cuántos huevos tiene una docena?',

    bateria:
        '¿Cuántas rayitas tiene la batería llena?',

    ruta:
        '¿En cuántas partes partiste el camino?'

};


const BEBIDAS = {

    jugo: {
        color: '#F59E0B',
        tapa: '#2E8B57'
    },

    gaseosa: {
        color: '#F28C28',
        tapa: '#C62828'
    },

    agua: {
        color: '#7EC8E3',
        tapa: '#1E88E5'
    }

};


// ============================================================================
// FUNCIONES AUXILIARES
// ============================================================================

const range = (
    cantidad
) => {

    return Array.from(
        {
            length: cantidad
        },
        (_, index) => index
    );
};


const cursor = (
    activo
) => ({
    cursor:
        activo
            ? 'pointer'
            : 'default'
});


const nPartes = (
    situacion
) => {

    return situacion.tipo ===
        'huevos'

        ? 12
        : situacion.partes;
};


const mezclar = (
    array
) => {

    const copia = [
        ...array
    ];


    for (
        let i = copia.length - 1;
        i > 0;
        i--
    ) {

        const j =
            Math.floor(
                Math.random() *
                (
                    i +
                    1
                )
            );


        [
            copia[i],
            copia[j]
        ] = [
            copia[j],
            copia[i]
        ];
    }


    return copia;
};


// ============================================================================
// RESPUESTA CORRECTA
// ============================================================================

const respuesta = (
    situacion
) => {

    const n =
        nPartes(
            situacion
        );


    const enteros =
        situacion.enteros ||
        1;


    if (
        situacion.mide ===
        'uno'
    ) {

        return {
            U: 1,
            n
        };
    }


    if (
        situacion.mide ===
        'sacado'
    ) {

        return {
            U:
                situacion.sacar,

            n
        };
    }


    return {

        U:
            enteros *
            n -
            situacion.sacar,

        n
    };
};


// ============================================================================
// SECTOR
// ============================================================================

const sector = (
    cx,
    cy,
    r,
    a0,
    a1
) => {

    if (
        a1 -
        a0 >=
        359.99
    ) {

        return (
            `M${cx - r} ${cy}
             A${r} ${r} 0 1 1 ${cx + r} ${cy}
             A${r} ${r} 0 1 1 ${cx - r} ${cy} Z`
        );
    }


    const punto = (
        angulo
    ) => [

        cx +
        r *
        Math.sin(
            (
                angulo *
                Math.PI
            ) /
            180
        ),

        cy -
        r *
        Math.cos(
            (
                angulo *
                Math.PI
            ) /
            180
        )
    ];


    const [
        x0,
        y0
    ] = punto(
        a0
    );


    const [
        x1,
        y1
    ] = punto(
        a1
    );


    const large =
        a1 -
        a0 >
        180

            ? 1
            : 0;


    return (
        `M${cx} ${cy}
         L${x0} ${y0}
         A${r} ${r} 0 ${large} 1 ${x1} ${y1}
         Z`
    );
};


const cortes = (
    cx,
    cy,
    r,
    n,
    offset,
    props
) => {

    if (
        n <
        2
    ) {

        return null;
    }


    return range(
        n
    )
        .map(
            index => {

                const angulo =
                    (
                        offset +
                        (
                            index *
                            360
                        ) /
                        n
                    ) *
                    Math.PI /
                    180;


                return (

                    <line
                        key={
                            index
                        }
                        x1={
                            cx
                        }
                        y1={
                            cy
                        }
                        x2={
                            cx +
                            r *
                            Math.sin(
                                angulo
                            )
                        }
                        y2={
                            cy -
                            r *
                            Math.cos(
                                angulo
                            )
                        }
                        {...props}
                    />
                );
            }
        );
};


// ============================================================================
// PIZZA
// ============================================================================

const INGREDIENTES = [

    [15, 80, 'a'],
    [100, 78, 'a'],
    [165, 82, 'a'],
    [205, 76, 'a'],
    [255, 80, 'a'],
    [320, 78, 'a'],

    [52, 44, 't'],
    [140, 42, 't'],
    [232, 44, 't'],
    [280, 40, 't'],
    [345, 46, 't'],
    [0, 0, 'a']

];


const PizzaUna = ({
    n,
    q,
    onTocar,
    activo,
    size
}) => {

    const cx = 150;
    const cy = 150;

    const paso =
        360 /
        n;


    return (

        <svg
            viewBox="0 0 300 300"
            style={{
                width:
                    size,

                height:
                    'auto',

                display:
                    'block'
            }}
            role="img"
            aria-label="Pizza"
        >

            <circle
                cx={cx}
                cy={cy}
                r={142}
                fill="#FFFFFF"
                stroke="#CFCFCF"
                strokeWidth={3}
            />


            {
                range(
                    n
                )
                    .map(
                        index => {

                            const a0 =
                                index *
                                paso;

                            const a1 =
                                (
                                    index +
                                    1
                                ) *
                                paso;


                            if (
                                q[
                                    index
                                ]
                            ) {

                                return (

                                    <path
                                        key={
                                            index
                                        }
                                        d={
                                            sector(
                                                cx,
                                                cy,
                                                126,
                                                a0 +
                                                0.8,
                                                a1 -
                                                0.8
                                            )
                                        }
                                        fill="#FFFFFF"
                                        stroke="#9E9E9E"
                                        strokeWidth={2.5}
                                        strokeDasharray="7 6"
                                        strokeLinejoin="round"
                                        onClick={() =>
                                            onTocar(
                                                index
                                            )
                                        }
                                        style={
                                            cursor(
                                                activo
                                            )
                                        }
                                    />
                                );
                            }


                            const propios =
                                INGREDIENTES
                                    .filter(
                                        (
                                            [
                                                angulo
                                            ]
                                        ) =>

                                            Math.floor(
                                                angulo /
                                                paso
                                            ) %
                                            n ===
                                            index
                                    );


                            return (

                                <g
                                    key={
                                        index
                                    }
                                    onClick={() =>
                                        onTocar(
                                            index
                                        )
                                    }
                                    style={
                                        cursor(
                                            activo
                                        )
                                    }
                                >

                                    <path
                                        d={
                                            sector(
                                                cx,
                                                cy,
                                                128,
                                                a0,
                                                a1
                                            )
                                        }
                                        fill="#D99A4E"
                                    />

                                    <path
                                        d={
                                            sector(
                                                cx,
                                                cy,
                                                112,
                                                a0,
                                                a1
                                            )
                                        }
                                        fill="#F7D774"
                                    />


                                    {
                                        propios.map(
                                            (
                                                [
                                                    angulo,
                                                    radio,
                                                    tipo
                                                ],
                                                k
                                            ) => {

                                                const x =
                                                    cx +
                                                    radio *
                                                    Math.sin(
                                                        (
                                                            angulo *
                                                            Math.PI
                                                        ) /
                                                        180
                                                    );

                                                const y =
                                                    cy -
                                                    radio *
                                                    Math.cos(
                                                        (
                                                            angulo *
                                                            Math.PI
                                                        ) /
                                                        180
                                                    );


                                                return tipo ===
                                                    'a'

                                                    ?

                                                    <g
                                                        key={
                                                            k
                                                        }
                                                    >

                                                        <circle
                                                            cx={x}
                                                            cy={y}
                                                            r={7}
                                                            fill="#2E3B1F"
                                                        />

                                                        <circle
                                                            cx={x}
                                                            cy={y}
                                                            r={2.5}
                                                            fill="#7A8A55"
                                                        />

                                                    </g>

                                                    :

                                                    <circle
                                                        key={
                                                            k
                                                        }
                                                        cx={x}
                                                        cy={y}
                                                        r={6}
                                                        fill="#D9442B"
                                                        opacity={0.85}
                                                    />;
                                            }
                                        )
                                    }

                                </g>
                            );
                        }
                    )
            }


            <g
                pointerEvents="none"
            >
                {
                    cortes(
                        cx,
                        cy,
                        130,
                        n,
                        0,
                        {
                            stroke:
                                '#FFFFFF',

                            strokeWidth:
                                5
                        }
                    )
                }
            </g>

        </svg>
    );
};


// ============================================================================
// HELADO
// ============================================================================

const HeladoUno = ({
    n,
    q,
    onTocar,
    activo,
    size
}) => {

    const sabores = [
        '#C68B4E',
        '#6B3E26',
        '#F4A3B4',
        '#F2EBB5',
        '#C5E1A5',
        '#FFCC80'
    ];


    const r = 110;
    const ry = 44;

    const k =
        ry /
        r;

    const cx = 160;
    const topY = 70;

    const paso =
        360 /
        n;

    const offset =
        n === 4
            ? 45
            : 0;


    return (

        <svg
            viewBox="0 0 320 260"
            style={{
                width:
                    size,

                height:
                    'auto',

                display:
                    'block'
            }}
            role="img"
            aria-label="Pote de un kilo de helado"
        >

            <g
                pointerEvents="none"
            >

                <path
                    d={
                        `M${cx - 128} ${topY}
                         L${cx - 98} ${topY + 160}
                         Q${cx} ${topY + 186} ${cx + 98} ${topY + 160}
                         L${cx + 128} ${topY} Z`
                    }
                    fill="#FFFFFF"
                    stroke="#BDBDBD"
                    strokeWidth={3}
                    strokeLinejoin="round"
                />

                <text
                    x={cx}
                    y={
                        topY +
                        120
                    }
                    textAnchor="middle"
                    fontSize="22"
                    fontWeight="800"
                    fill="#9E9E9E"
                    letterSpacing="2"
                >
                    1 KG
                </text>

                <ellipse
                    cx={cx}
                    cy={topY}
                    rx={128}
                    ry={50}
                    fill="#FFFFFF"
                    stroke="#BDBDBD"
                    strokeWidth={3}
                />

                <ellipse
                    cx={cx}
                    cy={topY}
                    rx={r + 2}
                    ry={ry + 1}
                    fill="#E9E9E9"
                />

            </g>


            <g
                transform={
                    `translate(${cx} ${topY}) scale(1 ${k})`
                }
            >

                {
                    range(
                        n
                    )
                        .map(
                            index => {

                                const a0 =
                                    offset +
                                    index *
                                    paso;

                                const a1 =
                                    offset +
                                    (
                                        index +
                                        1
                                    ) *
                                    paso;

                                const vacio =
                                    q[
                                        index
                                    ];


                                return (

                                    <g
                                        key={
                                            index
                                        }
                                        onClick={() =>
                                            onTocar(
                                                index
                                            )
                                        }
                                        style={
                                            cursor(
                                                activo
                                            )
                                        }
                                    >

                                        <path
                                            d={
                                                sector(
                                                    0,
                                                    0,
                                                    r,
                                                    a0,
                                                    a1
                                                )
                                            }
                                            fill={
                                                vacio

                                                    ? '#ECECEC'

                                                    : sabores[
                                                        index %
                                                        sabores.length
                                                    ]
                                            }
                                        />

                                    </g>
                                );
                            }
                        )
                }


                <g
                    pointerEvents="none"
                >
                    {
                        cortes(
                            0,
                            0,
                            r,
                            n,
                            offset,
                            {
                                stroke:
                                    '#FFFFFF',

                                strokeWidth:
                                    4,

                                vectorEffect:
                                    'non-scaling-stroke'
                            }
                        )
                    }
                </g>

            </g>

        </svg>
    );
};


// ============================================================================
// CHOCOLATE
// ============================================================================

const ChocolateUno = ({
    n,
    q,
    onTocar,
    activo,
    size
}) => {

    const x0 = 8;
    const y0 = 8;

    const W = 360;
    const H = 120;

    const cols = 12;
    const rows = 3;

    const cw =
        W /
        cols;

    const ch =
        H /
        rows;

    const pw =
        W /
        n;


    return (

        <svg
            viewBox="0 0 376 136"
            style={{
                width:
                    size,

                height:
                    'auto',

                display:
                    'block'
            }}
            role="img"
            aria-label="Chocolate"
        >

            <g
                pointerEvents="none"
            >

                <rect
                    x={
                        x0 -
                        4
                    }
                    y={
                        y0 -
                        4
                    }
                    width={
                        W +
                        8
                    }
                    height={
                        H +
                        8
                    }
                    rx={8}
                    fill="#7B4A2A"
                />


                {
                    range(
                        cols
                    )
                        .map(
                            columna =>

                                range(
                                    rows
                                )
                                    .map(
                                        fila => {

                                            const x =
                                                x0 +
                                                columna *
                                                cw +
                                                3;

                                            const y =
                                                y0 +
                                                fila *
                                                ch +
                                                3;

                                            const width =
                                                cw -
                                                6;

                                            const height =
                                                ch -
                                                6;


                                            return (

                                                <g
                                                    key={
                                                        `${columna}-${fila}`
                                                    }
                                                >

                                                    <rect
                                                        x={x}
                                                        y={y}
                                                        width={
                                                            width
                                                        }
                                                        height={
                                                            height
                                                        }
                                                        rx={3}
                                                        fill="#94592F"
                                                    />

                                                    <path
                                                        d={
                                                            `M${x + 2} ${y + height - 2}
                                                             L${x + 2} ${y + 2}
                                                             L${x + width - 2} ${y + 2}`
                                                        }
                                                        fill="none"
                                                        stroke="#B07446"
                                                        strokeWidth={2.5}
                                                        strokeLinecap="round"
                                                    />

                                                </g>
                                            );
                                        }
                                    )
                        )
                }


                {
                    range(
                        n
                    )
                        .map(
                            index =>

                                q[
                                    index
                                ] && (

                                    <g
                                        key={
                                            index
                                        }
                                    >

                                        <rect
                                            x={
                                                x0 +
                                                index *
                                                pw -
                                                4
                                            }
                                            y={0}
                                            width={
                                                pw +
                                                8
                                            }
                                            height={136}
                                            fill="#FFFFFF"
                                        />

                                        <rect
                                            x={
                                                x0 +
                                                index *
                                                pw +
                                                3
                                            }
                                            y={y0}
                                            width={
                                                pw -
                                                6
                                            }
                                            height={H}
                                            rx={6}
                                            fill="none"
                                            stroke="#9E9E9E"
                                            strokeWidth={2.5}
                                            strokeDasharray="7 6"
                                        />

                                    </g>
                                )
                        )
                }


                {
                    range(
                        n -
                        1
                    )
                        .map(
                            index => (

                                <line
                                    key={
                                        index
                                    }
                                    x1={
                                        x0 +
                                        (
                                            index +
                                            1
                                        ) *
                                        pw
                                    }
                                    y1={0}
                                    x2={
                                        x0 +
                                        (
                                            index +
                                            1
                                        ) *
                                        pw
                                    }
                                    y2={136}
                                    stroke="#FFFFFF"
                                    strokeWidth={6}
                                />
                            )
                        )
                }

            </g>


            {
                range(
                    n
                )
                    .map(
                        index => (

                            <rect
                                key={
                                    index
                                }
                                x={
                                    x0 +
                                    index *
                                    pw
                                }
                                y={0}
                                width={
                                    pw
                                }
                                height={136}
                                fill="transparent"
                                style={
                                    cursor(
                                        activo
                                    )
                                }
                                onClick={() =>
                                    onTocar(
                                        index
                                    )
                                }
                            />
                        )
                    )
            }

        </svg>
    );
};


// ============================================================================
// BOTELLA
// ============================================================================

const BotellaUna = ({
    n,
    q,
    onTocar,
    activo,
    size,
    bebida,
    id
}) => {

    const top = 105;
    const bottom = 290;

    const alto =
        bottom -
        top;

    const bh =
        alto /
        n;

    const nivel =
        n -
        q.filter(
            Boolean
        ).length;


    const {
        color,
        tapa
    } =
        BEBIDAS[
            bebida
        ] ||
        BEBIDAS.jugo;


    const contorno =
        'M62 22 h36 v33 q32 10 32 50 v165 q0 20 -20 20 h-60 q-20 0 -20 -20 v-165 q0 -40 32 -50 z';


    const clip =
        `clip-botella-${id}`;


    return (

        <svg
            viewBox="0 0 160 300"
            style={{
                width:
                    size,

                height:
                    'auto',

                display:
                    'block'
            }}
            role="img"
            aria-label={
                `Botella de ${bebida}`
            }
        >

            <defs>

                <clipPath
                    id={
                        clip
                    }
                >

                    <path
                        d={
                            contorno
                        }
                    />

                </clipPath>

            </defs>


            <g
                pointerEvents="none"
            >

                <path
                    d={
                        contorno
                    }
                    fill="#F7FBFC"
                />

                <rect
                    x={0}
                    y={
                        bottom -
                        nivel *
                        bh
                    }
                    width={160}
                    height={
                        nivel *
                        bh +
                        10
                    }
                    fill={
                        color
                    }
                    clipPath={
                        `url(#${clip})`
                    }
                />


                {
                    n >
                    1 &&

                    range(
                        n
                    )
                        .map(
                            index => {

                                const y =
                                    bottom -
                                    (
                                        index +
                                        1
                                    ) *
                                    bh;


                                return (

                                    <line
                                        key={
                                            index
                                        }
                                        x1={30}
                                        y1={y}
                                        x2={130}
                                        y2={y}
                                        stroke={INK}
                                        strokeWidth={2}
                                        strokeDasharray="6 5"
                                        opacity={0.7}
                                    />
                                );
                            }
                        )
                }


                <path
                    d={
                        contorno
                    }
                    fill="none"
                    stroke={INK}
                    strokeWidth={3}
                />


                <rect
                    x={58}
                    y={6}
                    width={44}
                    height={20}
                    rx={4}
                    fill={
                        tapa
                    }
                    stroke={INK}
                    strokeWidth={2}
                />

            </g>


            {
                range(
                    n
                )
                    .map(
                        index => (

                            <rect
                                key={
                                    index
                                }
                                x={28}
                                y={
                                    bottom -
                                    (
                                        index +
                                        1
                                    ) *
                                    bh
                                }
                                width={104}
                                height={
                                    bh
                                }
                                fill="transparent"
                                style={
                                    cursor(
                                        activo
                                    )
                                }
                                onClick={() =>
                                    onTocar(
                                        index
                                    )
                                }
                            />
                        )
                    )
            }

        </svg>
    );
};


// ============================================================================
// HUEVOS
// ============================================================================

const HuevosUna = ({
    q,
    onTocar,
    activo,
    size
}) => {

    const cols = 6;


    return (

        <svg
            viewBox="0 0 400 190"
            style={{
                width:
                    size,

                height:
                    'auto',

                display:
                    'block'
            }}
            role="img"
            aria-label="Huevera de una docena"
        >

            <rect
                x={10}
                y={20}
                width={380}
                height={160}
                rx={18}
                fill="#CDBB9E"
                stroke="#9C8A6E"
                strokeWidth={3}
            />


            {
                range(
                    12
                )
                    .map(
                        index => {

                            const x =
                                45 +
                                (
                                    index %
                                    cols
                                ) *
                                62;

                            const y =
                                65 +
                                Math.floor(
                                    index /
                                    cols
                                ) *
                                72;


                            return (

                                <g
                                    key={
                                        index
                                    }
                                    onClick={() =>
                                        onTocar(
                                            index
                                        )
                                    }
                                    style={
                                        cursor(
                                            activo
                                        )
                                    }
                                >

                                    <circle
                                        cx={x}
                                        cy={y}
                                        r={28}
                                        fill="#B6A385"
                                        stroke="#9C8A6E"
                                        strokeWidth={2}
                                    />


                                    {
                                        !q[
                                            index
                                        ] && (

                                            <>

                                                <ellipse
                                                    cx={x}
                                                    cy={
                                                        y -
                                                        4
                                                    }
                                                    rx={22}
                                                    ry={27}
                                                    fill="#FFF4E0"
                                                    stroke="#C9B48F"
                                                    strokeWidth={2}
                                                />

                                                <ellipse
                                                    cx={
                                                        x -
                                                        7
                                                    }
                                                    cy={
                                                        y -
                                                        14
                                                    }
                                                    rx={5}
                                                    ry={8}
                                                    fill="#FFFFFF"
                                                    opacity={0.8}
                                                />

                                            </>
                                        )
                                    }

                                </g>
                            );
                        }
                    )
            }

        </svg>
    );
};


// ============================================================================
// BATERÍA
// ============================================================================

const BateriaUna = ({
    n,
    q,
    onTocar,
    activo,
    size
}) => {

    const w = 300;
    const h = 130;

    const pad = 12;

    const gap =
        n >
        6

            ? 5
            : 8;


    const segW =
        (
            w -
            pad *
            2 -
            gap *
            (
                n -
                1
            )
        ) /
        n;


    const nivel =
        n -
        q.filter(
            Boolean
        ).length;


    return (

        <svg
            viewBox="0 0 340 150"
            style={{
                width:
                    size,

                height:
                    'auto',

                display:
                    'block'
            }}
            role="img"
            aria-label="Batería"
        >

            <rect
                x={6}
                y={10}
                width={w}
                height={h}
                rx={18}
                fill="#FFFFFF"
                stroke={INK}
                strokeWidth={5}
            />

            <rect
                x={
                    w +
                    6
                }
                y={
                    10 +
                    h /
                    2 -
                    22
                }
                width={20}
                height={44}
                rx={6}
                fill={INK}
            />


            {
                range(
                    n
                )
                    .map(
                        index => (

                            <rect
                                key={
                                    index
                                }
                                x={
                                    6 +
                                    pad +
                                    index *
                                    (
                                        segW +
                                        gap
                                    )
                                }
                                y={
                                    10 +
                                    pad
                                }
                                width={
                                    segW
                                }
                                height={
                                    h -
                                    pad *
                                    2
                                }
                                rx={5}
                                fill={
                                    index <
                                    nivel

                                        ? '#43A047'
                                        : '#FFFFFF'
                                }
                                stroke={
                                    index <
                                    nivel

                                        ? '#2E7D32'
                                        : '#BDBDBD'
                                }
                                strokeWidth={2.5}
                                style={
                                    cursor(
                                        activo
                                    )
                                }
                                onClick={() =>
                                    onTocar(
                                        index
                                    )
                                }
                            />
                        )
                    )
            }

        </svg>
    );
};


// ============================================================================
// RUTA
// ============================================================================

const Auto = ({
    x,
    y
}) => {

    return (

        <g
            transform={
                `translate(${x - 30} ${y - 30})`
            }
            pointerEvents="none"
        >

            <path
                d="M8 24 L16 10 Q18 6 23 6 L40 6 Q45 6 48 10 L54 18 L58 19 Q62 20 62 25 L62 32 L4 32 L4 27 Q4 24 8 24 Z"
                fill={MARK}
            />

            <circle
                cx={17}
                cy={32}
                r={7}
                fill={INK}
            />

            <circle
                cx={49}
                cy={32}
                r={7}
                fill={INK}
            />

        </g>
    );
};


const Casa = ({
    x,
    y,
    techo = '#C0392B'
}) => {

    return (

        <g
            transform={
                `translate(${x} ${y})`
            }
        >

            <polygon
                points="-40,-46 0,-80 40,-46"
                fill={
                    techo
                }
            />

            <rect
                x={-32}
                y={-46}
                width={64}
                height={46}
                fill="#F4D9A8"
            />

            <rect
                x={-9}
                y={-28}
                width={18}
                height={28}
                fill="#8D5524"
            />

        </g>
    );
};


const Playa = ({
    x,
    y
}) => {

    return (

        <g
            transform={
                `translate(${x} ${y})`
            }
        >

            <circle
                cx={30}
                cy={-82}
                r={16}
                fill="#FFC93C"
            />

            <path
                d="M-50 0 Q-30 -22 0 -18 Q30 -14 50 0 Z"
                fill="#F3D9A4"
            />

            <path
                d="M-50 -24 q10 -8 20 0 t20 0 t20 0 t20 0 t20 0"
                fill="none"
                stroke="#4FA3D1"
                strokeWidth={4}
                strokeLinecap="round"
            />

        </g>
    );
};


const Montana = ({
    x,
    y
}) => {

    return (

        <g
            transform={
                `translate(${x} ${y})`
            }
        >

            <polygon
                points="-55,0 -15,-78 25,0"
                fill="#7E8C9A"
            />

            <polygon
                points="-5,0 28,-58 60,0"
                fill="#5F6E7C"
            />

        </g>
    );
};


const DESTINOS = {

    playa: {
        nombre:
            'La playa',

        Icono:
            Playa
    },

    montaña: {
        nombre:
            'La montaña',

        Icono:
            Montana
    },

    abuela: {
        nombre:
            'La abuela',

        Icono:
            props => (
                <Casa
                    {...props}
                    techo="#6A5ACD"
                />
            )
    }

};


const Ruta = ({
    s,
    n,
    recorrido,
    onTocar,
    activo
}) => {

    const x1 = 150;
    const x2 = 620;

    const roadY = 150;

    const len =
        x2 -
        x1;

    const pw =
        len /
        n;


    const pinta =
        s.sacar !==
        null;


    const destino =
        DESTINOS[
            s.destino
        ] ||
        DESTINOS.playa;


    const IconoDestino =
        destino.Icono;


    return (

        <svg
            viewBox="0 0 760 230"
            style={{
                width:
                    '100%',

                maxWidth:
                    760,

                height:
                    'auto',

                display:
                    'block'
            }}
            role="img"
            aria-label="Camino del viaje"
        >

            <g
                pointerEvents="none"
            >

                <Casa
                    x={80}
                    y={
                        roadY +
                        18
                    }
                />

                <IconoDestino
                    x={685}
                    y={
                        roadY +
                        18
                    }
                />


                <text
                    x={80}
                    y={
                        roadY +
                        48
                    }
                    textAnchor="middle"
                    fontSize="18"
                    fontWeight="700"
                    fill={INK}
                >
                    Casa
                </text>


                <text
                    x={685}
                    y={
                        roadY +
                        48
                    }
                    textAnchor="middle"
                    fontSize="18"
                    fontWeight="700"
                    fill={INK}
                >
                    {
                        destino.nombre
                    }
                </text>


                <rect
                    x={x1}
                    y={
                        roadY -
                        16
                    }
                    width={
                        len
                    }
                    height={32}
                    rx={4}
                    fill="#555555"
                />


                {
                    recorrido >
                    0 && (

                        <rect
                            x={x1}
                            y={
                                roadY -
                                16
                            }
                            width={
                                recorrido *
                                pw
                            }
                            height={32}
                            fill={
                                PINTADO
                            }
                        />
                    )
                }


                <line
                    x1={
                        x1 +
                        6
                    }
                    y1={
                        roadY
                    }
                    x2={
                        x2 -
                        6
                    }
                    y2={
                        roadY
                    }
                    stroke="#FFFFFF"
                    strokeWidth={3}
                    strokeDasharray="14 12"
                />


                {
                    range(
                        n -
                        1
                    )
                        .map(
                            index => (

                                <line
                                    key={
                                        index
                                    }
                                    x1={
                                        x1 +
                                        (
                                            index +
                                            1
                                        ) *
                                        pw
                                    }
                                    y1={
                                        roadY -
                                        18
                                    }
                                    x2={
                                        x1 +
                                        (
                                            index +
                                            1
                                        ) *
                                        pw
                                    }
                                    y2={
                                        roadY +
                                        18
                                    }
                                    stroke="#FFFFFF"
                                    strokeWidth={5}
                                />
                            )
                        )
                }


                {
                    pinta && (

                        <Auto
                            x={
                                x1 +
                                recorrido *
                                pw
                            }
                            y={
                                roadY -
                                22
                            }
                        />
                    )
                }

            </g>


            {
                pinta &&

                range(
                    n
                )
                    .map(
                        index => (

                            <rect
                                key={
                                    index
                                }
                                x={
                                    x1 +
                                    index *
                                    pw
                                }
                                y={
                                    roadY -
                                    20
                                }
                                width={
                                    pw
                                }
                                height={40}
                                fill="transparent"
                                style={
                                    cursor(
                                        activo
                                    )
                                }
                                onClick={() =>
                                    onTocar(
                                        0,
                                        index
                                    )
                                }
                            />
                        )
                    )
            }

        </svg>
    );
};


// ============================================================================
// DIBUJO GENERAL
// ============================================================================

const UNO = {

    pizza:
        PizzaUna,

    helado:
        HeladoUno,

    chocolate:
        ChocolateUno,

    botella:
        BotellaUna,

    huevos:
        HuevosUna,

    bateria:
        BateriaUna

};


const tamano = (
    tipo,
    cantidadEnteros
) => {

    if (
        tipo ===
        'pizza'
    ) {

        if (
            cantidadEnteros ===
            1
        ) {
            return 230;
        }

        if (
            cantidadEnteros ===
            2
        ) {
            return 175;
        }

        if (
            cantidadEnteros ===
            3
        ) {
            return 135;
        }

        return 115;
    }


    if (
        tipo ===
        'helado'
    ) {

        return cantidadEnteros ===
            1

            ? 240
            : 180;
    }


    if (
        tipo ===
        'chocolate'
    ) {

        if (
            cantidadEnteros ===
            1
        ) {
            return 400;
        }

        if (
            cantidadEnteros ===
            2
        ) {
            return 220;
        }

        return 160;
    }


    if (
        tipo ===
        'botella'
    ) {

        if (
            cantidadEnteros ===
            1
        ) {
            return 125;
        }

        if (
            cantidadEnteros ===
            2
        ) {
            return 100;
        }

        return 90;
    }


    if (
        tipo ===
        'huevos'
    ) {

        return cantidadEnteros ===
            1

            ? 340
            : 250;
    }


    return 330;
};


const Dibujo = ({
    s,
    n,
    quitadas,
    recorrido,
    onTocar,
    activo
}) => {


    if (
        s.tipo ===
        'ruta'
    ) {

        return (

            <Ruta
                s={s}
                n={n}
                recorrido={
                    recorrido
                }
                onTocar={
                    onTocar
                }
                activo={
                    activo
                }
            />
        );
    }


    const cantidadEnteros =
        s.enteros ||
        1;


    const Uno =
        UNO[
            s.tipo
        ];


    return (

        <div
            style={{
                width:
                    '100%',

                display:
                    'flex',

                flexWrap:
                    'wrap',

                gap:
                    10,

                justifyContent:
                    'center',

                alignItems:
                    'flex-end'
            }}
        >

            {
                range(
                    cantidadEnteros
                )
                    .map(
                        entero => (

                            <Uno
                                key={
                                    entero
                                }
                                id={
                                    `${s.id}-${entero}`
                                }
                                n={
                                    n
                                }
                                q={
                                    quitadas.slice(
                                        entero *
                                        n,

                                        entero *
                                        n +
                                        n
                                    )
                                }
                                onTocar={
                                    index =>
                                        onTocar(
                                            entero,
                                            index
                                        )
                                }
                                activo={
                                    activo
                                }
                                size={
                                    tamano(
                                        s.tipo,
                                        cantidadEnteros
                                    )
                                }
                                bebida={
                                    s.bebida
                                }
                            />
                        )
                    )
            }

        </div>
    );
};


// ============================================================================
// CONTADOR
// ============================================================================

const botonContador = {

    fontFamily:
        'Nunito',

    fontSize:
        22,

    fontWeight:
        700,

    width:
        42,

    height:
        36,

    borderRadius:
        10,

    border:
        `2px solid ${ACCENT}`,

    background:
        '#FFFFFF',

    color:
        ACCENT,

    cursor:
        'pointer'
};


const Caja = ({
    valor
}) => {

    return (

        <div
            style={{
                width:
                    56,

                height:
                    56,

                border:
                    `3px solid ${INK}`,

                borderRadius:
                    10,

                display:
                    'flex',

                alignItems:
                    'center',

                justifyContent:
                    'center',

                fontFamily:
                    'Nunito',

                fontSize:
                    30,

                fontWeight:
                    700,

                color:
                    valor === null

                        ? '#AAAAAA'
                        : INK
            }}
        >
            {
                valor === null
                    ? '?'
                    : valor
            }
        </div>
    );
};


const Contador = ({
    valor,
    onCambio,
    min,
    disabled,
    etiqueta,
    vertical = false
}) => {


    const restar = () => {

        if (
            disabled
        ) {
            return;
        }


        onCambio(

            valor === null

                ? min

                : Math.max(
                    min,
                    valor -
                    1
                )
        );
    };


    const sumar = () => {

        if (
            disabled
        ) {
            return;
        }


        onCambio(

            valor === null

                ? Math.max(
                    min,
                    1
                )

                : Math.min(
                    30,
                    valor +
                    1
                )
        );
    };


    const menos = (

        <button
            type="button"
            style={
                botonContador
            }
            disabled={
                disabled
            }
            aria-label={
                `Restar ${etiqueta}`
            }
            onClick={
                restar
            }
        >
            −
        </button>
    );


    const mas = (

        <button
            type="button"
            style={
                botonContador
            }
            disabled={
                disabled
            }
            aria-label={
                `Sumar ${etiqueta}`
            }
            onClick={
                sumar
            }
        >
            +
        </button>
    );


    return (

        <div
            style={{
                display:
                    'flex',

                flexDirection:
                    vertical
                        ? 'column'
                        : 'row',

                alignItems:
                    'center',

                gap:
                    vertical
                        ? 8
                        : 10
            }}
        >

            {
                vertical
                    ? mas
                    : menos
            }


            <Caja
                valor={
                    valor
                }
            />


            {
                vertical
                    ? menos
                    : mas
            }

        </div>
    );
};


// ============================================================================
// ESTADO INICIAL DE CADA PROBLEMA
// ============================================================================

const inicial = (
    situacion
) => {

    const divisible =
        DIVISIBLES.includes(
            situacion.tipo
        );


    const n =
        divisible

            ? 1
            : nPartes(
                situacion
            );


    return {

        fase:
            divisible
                ? 'partir'
                : 'sacar',

        n,

        quitadas:
            Array(
                (
                    situacion.enteros ||
                    1
                ) *
                n
            ).fill(
                false
            ),

        recorrido:
            0
    };
};


// ============================================================================
// TEXTO PARA PARTIR
// ============================================================================

const textoPartir = (
    situacion
) => {

    const tipo =
        TIPO[
            situacion.tipo
        ];


    const varios =
        (
            situacion.enteros ||
            1
        ) >
        1;


    if (
        situacion.tipo ===
        'botella'
    ) {

        return (
            `Marcá los vasos de ${varios ? 'cada botella' : 'la botella'}.`
        );
    }


    if (
        situacion.tipo ===
        'helado'
    ) {

        return (
            `Partí ${varios ? 'cada kilo' : 'el kilo'} en gustos iguales.`
        );
    }


    return (
        `Partí ${tipo.cosa[varios ? 1 : 0]} en partes iguales.`
    );
};


// ============================================================================
// FORMATO PARA GUARDAR
// ============================================================================

const formatearRespuesta = (
    entero,
    numerador,
    denominador
) => {

    const e =
        entero ||
        0;


    if (
        e >
        0
    ) {

        return (
            `${e} y ${numerador}/${denominador}`
        );
    }


    return (
        `${numerador}/${denominador}`
    );
};


// ============================================================================
// M153
// ============================================================================

const M153 = () => {


    const dispatch =
        useDispatch();


    const navigate =
        useNavigate();


    const [config] =
        useConfigAuth();


    // ------------------------------------------------------------------------
    // REDUX
    // ------------------------------------------------------------------------

    const iniciar =
        useSelector(
            state =>
                state.ejercicio.iniciar
        );


    const finalizar =
        useSelector(
            state =>
                state.ejercicio.finalizar
        );


    const id_paciente =
        useSelector(
            state =>
                state.usuario.id_paciente
        );


    const sesion =
        useSelector(
            state =>
                state.ejercicio.sesion
        );


    // ------------------------------------------------------------------------
    // EJERCICIOS
    // ------------------------------------------------------------------------

    const [
        ejercicios,
        setEjercicios
    ] = useState([]);


    const [
        count,
        setCount
    ] = useState(1);


    // ------------------------------------------------------------------------
    // ESTADO DEL PROBLEMA
    // ------------------------------------------------------------------------

    const [
        estado,
        setEstado
    ] = useState(null);


    // ------------------------------------------------------------------------
    // RESPUESTA
    // ------------------------------------------------------------------------

    const [
        ent,
        setEnt
    ] = useState(null);


    const [
        num,
        setNum
    ] = useState(null);


    const [
        den,
        setDen
    ] = useState(null);


    // ------------------------------------------------------------------------
    // FEEDBACK
    // ------------------------------------------------------------------------

    const [
        feedback,
        setFeedback
    ] = useState(null);


    const [
        disable,
        setDisable
    ] = useState(false);


    // ------------------------------------------------------------------------
    // ERRORES
    // ------------------------------------------------------------------------

    const [
        contarErrores,
        setContarErrores
    ] = useState(0);


    const [
        erroresItemActual,
        setErroresItemActual
    ] = useState(0);


    const [
        erroresOrden,
        setErroresOrden
    ] = useState([]);


    // ------------------------------------------------------------------------
    // RESPUESTAS
    // ------------------------------------------------------------------------

    const [
        respuestasOrden,
        setRespuestasOrden
    ] = useState([]);


    // ------------------------------------------------------------------------
    // ACTUAL
    // ------------------------------------------------------------------------

    const ejercicioActual =
        ejercicios.length >
        0

            ? ejercicios[
                count -
                1
            ]

            : null;


    const fase =
        estado
            ? estado.fase
            : null;


    const escribe =
        fase ===
        'escribir' ||
        fase ===
        'listo';


    // ------------------------------------------------------------------------
    // SONIDOS
    // ------------------------------------------------------------------------

    const GoodWork = () => {

        new Audio(
            '/sounds/sonido_bien.mp3'
        ).play();
    };


    const TryAgain = () => {

        new Audio(
            '/sounds/sonidoMal.mp3'
        ).play();
    };


    // ------------------------------------------------------------------------
    // ERROR
    // ------------------------------------------------------------------------

    const marcarError = (
        texto
    ) => {

        setContarErrores(
            errores =>
                errores +
                1
        );


        setErroresItemActual(
            errores =>
                errores +
                1
        );


        setFeedback({
            ok:
                false,

            text:
                texto
        });


        setDisable(
            true
        );


        TryAgain();


        setTimeout(() => {

            setDisable(
                false
            );

        }, 500);
    };


    // ------------------------------------------------------------------------
    // TOCAR REPRESENTACIÓN
    // ------------------------------------------------------------------------

    const tocar = (
        entero,
        parte
    ) => {

        if (
            disable ||
            fase !==
            'sacar'
        ) {

            return;
        }


        setFeedback(
            null
        );


        const {
            n,
            quitadas,
            recorrido
        } = estado;


        // --------------------------------------------------------------------
        // RUTA
        // --------------------------------------------------------------------

        if (
            ejercicioActual.tipo ===
            'ruta'
        ) {

            setEstado({

                ...estado,

                recorrido:
                    recorrido ===
                    parte +
                    1

                        ? parte
                        : parte +
                        1
            });


            return;
        }


        // --------------------------------------------------------------------
        // BOTELLA / BATERÍA
        // --------------------------------------------------------------------

        if (
            ejercicioActual.tipo ===
            'botella' ||
            ejercicioActual.tipo ===
            'bateria'
        ) {

            const tramo =
                quitadas.slice(
                    entero *
                    n,

                    entero *
                    n +
                    n
                );


            const nivel =
                n -
                tramo.filter(
                    Boolean
                ).length;


            const nuevo =
                parte <
                nivel

                    ? parte
                    : parte +
                    1;


            const nuevasQuitadas = [
                ...quitadas
            ];


            range(
                n
            )
                .forEach(
                    index => {

                        nuevasQuitadas[
                            entero *
                            n +
                            index
                        ] =
                            index >=
                            nuevo;
                    }
                );


            setEstado({

                ...estado,

                quitadas:
                    nuevasQuitadas
            });


            return;
        }


        // --------------------------------------------------------------------
        // RESTO
        // --------------------------------------------------------------------

        const posicion =
            entero *
            n +
            parte;


        setEstado({

            ...estado,

            quitadas:
                quitadas.map(
                    (
                        valor,
                        index
                    ) =>

                        index ===
                        posicion

                            ? !valor
                            : valor
                )
        });
    };


    // ------------------------------------------------------------------------
    // CAMBIAR PARTES
    // ------------------------------------------------------------------------

    const cambiarPartes = (
        delta
    ) => {

        if (
            disable ||
            fase !==
            'partir'
        ) {

            return;
        }


        const cantidadEnteros =
            ejercicioActual.enteros ||
            1;


        const nuevasPartes =
            Math.max(
                1,
                Math.min(
                    MAX_PARTES,
                    estado.n +
                    delta
                )
            );


        setEstado({

            ...estado,

            n:
                nuevasPartes,

            quitadas:
                Array(
                    cantidadEnteros *
                    nuevasPartes
                ).fill(
                    false
                )
        });


        setFeedback(
            null
        );
    };


    // ------------------------------------------------------------------------
    // COMPROBAR
    // ------------------------------------------------------------------------

    const comprobar = () => {

        if (
            disable ||
            !ejercicioActual ||
            !estado
        ) {

            return;
        }


        const tipo =
            TIPO[
                ejercicioActual.tipo
            ];


        // ====================================================================
        // FASE 1: PARTIR
        // ====================================================================

        if (
            fase ===
            'partir'
        ) {

            if (
                estado.n <
                ejercicioActual.partes
            ) {

                marcarError(
                    'Te faltan partes. Leé otra vez el problema: ¿en cuántas partes iguales hay que partir?'
                );

                return;
            }


            if (
                estado.n >
                ejercicioActual.partes
            ) {

                marcarError(
                    'Partiste de más. Leé otra vez el problema: ¿en cuántas partes iguales hay que partir?'
                );

                return;
            }


            const sigue =
                ejercicioActual.sacar !==
                null

                    ? 'sacar'
                    : 'escribir';


            setEstado({

                ...estado,

                fase:
                    sigue
            });


            setFeedback({

                ok:
                    true,

                text:
                    sigue ===
                    'sacar'

                        ? '¡Muy bien! Ahora representá lo que dice el problema.'
                        : '¡Muy bien! Ahora escribí la respuesta.'
            });


            GoodWork();


            return;
        }


        // ====================================================================
        // FASE 2: SACAR / PINTAR
        // ====================================================================

        if (
            fase ===
            'sacar'
        ) {

            const hecho =
                ejercicioActual.tipo ===
                'ruta'

                    ? estado.recorrido

                    : estado.quitadas.filter(
                        Boolean
                    ).length;


            const pintar =
                ejercicioActual.tipo ===
                'ruta';


            if (
                hecho <
                ejercicioActual.sacar
            ) {

                marcarError(

                    pintar

                        ? 'Te falta pintar. Leé otra vez el problema.'

                        : `Te faltan ${tipo.unidad[1]}. Leé otra vez el problema.`
                );

                return;
            }


            if (
                hecho >
                ejercicioActual.sacar
            ) {

                marcarError(

                    pintar

                        ? 'Pintaste de más. Leé otra vez el problema.'

                        : `Sacaste ${tipo.unidad[1]} de más. Leé otra vez el problema.`
                );

                return;
            }


            setEstado({

                ...estado,

                fase:
                    'escribir'
            });


            setFeedback({

                ok:
                    true,

                text:
                    '¡Muy bien! Ahora escribí la respuesta.'
            });


            GoodWork();


            return;
        }


        // ====================================================================
        // FASE 3: ESCRIBIR
        // ====================================================================

        if (
            fase ===
            'escribir'
        ) {

            if (
                num ===
                null ||
                den ===
                null
            ) {

                marcarError(
                    'Completá la fracción.'
                );

                return;
            }


            const {
                U,
                n: N
            } =
                respuesta(
                    ejercicioActual
                );


            const entero =
                ent ||
                0;


            // ----------------------------------------------------------------
            // ACEPTAMOS EQUIVALENTES Y NÚMEROS MIXTOS
            // ----------------------------------------------------------------

            const correcto =
                (
                    entero *
                    den +
                    num
                ) *
                N ===
                U *
                den;


            if (
                !correcto
            ) {

                if (
                    den !==
                    N &&
                    N %
                    den !==
                    0
                ) {

                    marcarError(
                        PISTA_DEN[
                            ejercicioActual.tipo
                        ]
                    );

                    return;
                }


                if (
                    U >
                    N
                ) {

                    marcarError(
                        'Contá primero los enteros que están completos. Después contá las partes sueltas.'
                    );

                    return;
                }


                if (
                    ejercicioActual.mide ===
                    'uno'
                ) {

                    marcarError(
                        '¿Cuántas partes le tocan a cada uno?'
                    );

                    return;
                }


                if (
                    ejercicioActual.mide ===
                    'sacado'
                ) {

                    marcarError(

                        ejercicioActual.tipo ===
                        'ruta'

                            ? 'Contá los tramos pintados.'

                            : `Ojo: la pregunta es por lo que se sacó. Contá ${tipo.art[1]} ${tipo.unidad[1]}.`
                    );

                    return;
                }


                marcarError(

                    ejercicioActual.tipo ===
                    'ruta'

                        ? 'Contá los tramos que no pintaste.'

                        : `Contá ${tipo.art[0]} ${tipo.unidad[1]} que quedaron.`
                );


                return;
            }


            // ----------------------------------------------------------------
            // CORRECTO
            // ----------------------------------------------------------------

            setEstado({

                ...estado,

                fase:
                    'listo'
            });


            setDisable(
                true
            );


            setFeedback({

                ok:
                    true,

                text:
                    '¡Muy bien!'
            });


            GoodWork();


            const respuestaUsada =
                formatearRespuesta(
                    ent,
                    num,
                    den
                );


            const nuevasRespuestas = [

                ...respuestasOrden,

                respuestaUsada

            ];


            const nuevosErrores = [

                ...erroresOrden,

                erroresItemActual

            ];


            setRespuestasOrden(
                nuevasRespuestas
            );


            setErroresOrden(
                nuevosErrores
            );


            // ----------------------------------------------------------------
            // SIGUIENTE
            // ----------------------------------------------------------------

            if (
                count <
                ejercicios.length
            ) {

                setTimeout(() => {

                    const siguiente =
                        ejercicios[
                            count
                        ];


                    setCount(
                        contador =>
                            contador +
                            1
                    );


                    setEstado(
                        inicial(
                            siguiente
                        )
                    );


                    setEnt(
                        null
                    );

                    setNum(
                        null
                    );

                    setDen(
                        null
                    );

                    setFeedback(
                        null
                    );

                    setDisable(
                        false
                    );

                    setErroresItemActual(
                        0
                    );

                }, 1000);

            } else {

                setTimeout(() => {

                    dispatch(
                        finalizarEjercicioAction()
                    );

                }, 1500);
            }
        }
    };


    // =========================================================================
    // GENERAR EJERCICIOS
    // =========================================================================

    useEffect(() => {

        const modelo =
            mezclar(
                EJERCICIOS
            )
                .slice(
                    0,
                    CANTIDAD_EJERCICIOS
                );


        setEjercicios(
            modelo
        );


        if (
            modelo.length >
            0
        ) {

            setEstado(
                inicial(
                    modelo[0]
                )
            );
        }


        dispatch(
            setearEjercicioAction(
                'M153'
            )
        );


        dispatch(
            setearUrlAnteriorAction(
                'matematica/fracciones/'
            )
        );


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // =========================================================================
    // GUARDAR
    // =========================================================================

    useEffect(() => {

        if (
            !finalizar
        ) {

            return;
        }


        const informacion = {

            config,

            payload: {

                ejercicio:
                    'M153',

                errores:
                    contarErrores,

                lista_usada:
                    respuestasOrden,

                erroresOrden,

                id_paciente,

                sesion
            }
        };


        dispatch(
            almacenarAction(
                informacion
            )
        );


        navigate(
            '/escritorio/metodos/finalizar-ejercicio'
        );


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);


    // =========================================================================
    // INSTRUCCIONES
    // =========================================================================

    if (
        !iniciar
    ) {

        return (

            <Fragment>

                <HeaderEjercicios
                    estrellas={true}
                    carrito={true}
                    minMay={false}
                />


                <Instrucciones
                    miniInstrucciones={
                        miniInstrucciones
                    }
                />

            </Fragment>
        );
    }


    if (
        !ejercicioActual ||
        !estado
    ) {

        return null;
    }


    // =========================================================================
    // RENDER
    // =========================================================================

    return (

        <PantallaM153>


            <HeaderEjercicios
                estrellas={true}
                carrito={true}
                minMay={false}
            />


            <ContenidoM153>


                {/* ========================================================= */}
                {/* ENUNCIADO                                                 */}
                {/* ========================================================= */}

                <EnunciadoM153>

                    {
                        ejercicioActual
                            .lineas
                            .map(
                                (
                                    linea,
                                    index
                                ) => {

                                    const pregunta =
                                        index ===
                                        ejercicioActual
                                            .lineas
                                            .length -
                                        1;


                                    return (

                                        <p
                                            key={
                                                index
                                            }
                                            className={
                                                pregunta
                                                    ? 'pregunta'
                                                    : ''
                                            }
                                        >
                                            {
                                                linea
                                            }
                                        </p>
                                    );
                                }
                            )
                    }

                </EnunciadoM153>


                {/* ========================================================= */}
                {/* ZONA CENTRAL                                              */}
                {/* ========================================================= */}

                <ZonaCentralM153>


                    {/* ===================================================== */}
                    {/* IZQUIERDA                                             */}
                    {/* ===================================================== */}

                    <PanelIzquierdoM153>


                        <EscenaM153>

                            <Dibujo
                                s={
                                    ejercicioActual
                                }
                                n={
                                    estado.n
                                }
                                quitadas={
                                    estado.quitadas
                                }
                                recorrido={
                                    estado.recorrido
                                }
                                onTocar={
                                    tocar
                                }
                                activo={
                                    fase ===
                                    'sacar' &&
                                    !disable
                                }
                            />

                        </EscenaM153>


                        {/* ================================================= */}
                        {/* PARTIR                                            */}
                        {/* ================================================= */}

                        {
                            fase ===
                            'partir' && (

                                <>

                                    <p
                                        style={{
                                            fontFamily:
                                                'Nunito',

                                            fontSize:
                                                17,

                                            fontWeight:
                                                600,

                                            color:
                                                '#555555',

                                            margin:
                                                0,

                                            textAlign:
                                                'center'
                                        }}
                                    >
                                        {
                                            textoPartir(
                                                ejercicioActual
                                            )
                                        }
                                    </p>


                                    <div
                                        style={{
                                            display:
                                                'flex',

                                            alignItems:
                                                'center',

                                            justifyContent:
                                                'center',

                                            gap:
                                                12,

                                            fontFamily:
                                                'Nunito',

                                            fontSize:
                                                20,

                                            fontWeight:
                                                700
                                        }}
                                    >

                                        <span>
                                            Partir en:
                                        </span>


                                        <button
                                            type="button"
                                            style={{
                                                ...botonContador,

                                                opacity:
                                                    estado.n <=
                                                    1

                                                        ? 0.4
                                                        : 1
                                            }}
                                            disabled={
                                                estado.n <=
                                                1
                                            }
                                            onClick={() =>
                                                cambiarPartes(
                                                    -1
                                                )
                                            }
                                        >
                                            −
                                        </button>


                                        <span
                                            style={{
                                                minWidth:
                                                    30,

                                                textAlign:
                                                    'center',

                                                fontSize:
                                                    26
                                            }}
                                        >
                                            {
                                                estado.n
                                            }
                                        </span>


                                        <button
                                            type="button"
                                            style={{
                                                ...botonContador,

                                                opacity:
                                                    estado.n >=
                                                    MAX_PARTES

                                                        ? 0.4
                                                        : 1
                                            }}
                                            disabled={
                                                estado.n >=
                                                MAX_PARTES
                                            }
                                            onClick={() =>
                                                cambiarPartes(
                                                    1
                                                )
                                            }
                                        >
                                            +
                                        </button>

                                    </div>

                                </>
                            )
                        }


                        {/* ================================================= */}
                        {/* REPRESENTAR                                       */}
                        {/* ================================================= */}

                        {
                            fase ===
                            'sacar' && (

                                <p
                                    style={{
                                        fontFamily:
                                            'Nunito',

                                        fontSize:
                                            17,

                                        fontWeight:
                                            600,

                                        color:
                                            '#555555',

                                        margin:
                                            0,

                                        textAlign:
                                            'center'
                                    }}
                                >
                                    {
                                        ejercicioActual
                                            .instruccion
                                    }
                                </p>
                            )
                        }


                        {/* ================================================= */}
                        {/* REPRESENTACIÓN TERMINADA                          */}
                        {/* ================================================= */}

                        {
                            escribe && (

                                <p
                                    style={{
                                        fontFamily:
                                            'Nunito',

                                        fontSize:
                                            17,

                                        color:
                                            '#555555',

                                        margin:
                                            0,

                                        marginTop:
                                            'auto',

                                        textAlign:
                                            'center'
                                    }}
                                >
                                    Así quedó la representación.
                                </p>
                            )
                        }


                    </PanelIzquierdoM153>


                    {/* ===================================================== */}
                    {/* DERECHA                                               */}
                    {/* ===================================================== */}

                    <PanelDerechoM153
                        $visible={
                            escribe
                        }
                    >

                        {
                            escribe && (

                                <RespuestaM153>


                                    <p
                                        style={{
                                            fontFamily:
                                                'Nunito',

                                            fontSize:
                                                21,

                                            fontWeight:
                                                700,

                                            textAlign:
                                                'center',

                                            margin:
                                                0
                                        }}
                                    >
                                        Tu respuesta
                                    </p>


                                    <div
                                        style={{
                                            display:
                                                'flex',

                                            alignItems:
                                                'center',

                                            justifyContent:
                                                'center',

                                            gap:
                                                20
                                        }}
                                    >


                                        {/* ENTEROS */}

                                        <Contador
                                            valor={
                                                ent
                                            }
                                            onCambio={
                                                valor => {

                                                    setEnt(
                                                        valor
                                                    );

                                                    setFeedback(
                                                        null
                                                    );
                                                }
                                            }
                                            min={
                                                0
                                            }
                                            disabled={
                                                fase ===
                                                'listo'
                                            }
                                            etiqueta="enteros"
                                            vertical={
                                                true
                                            }
                                        />


                                        {/* FRACCIÓN */}

                                        <div
                                            style={{
                                                display:
                                                    'flex',

                                                flexDirection:
                                                    'column',

                                                alignItems:
                                                    'center',

                                                gap:
                                                    8
                                            }}
                                        >

                                            <Contador
                                                valor={
                                                    num
                                                }
                                                onCambio={
                                                    valor => {

                                                        setNum(
                                                            valor
                                                        );

                                                        setFeedback(
                                                            null
                                                        );
                                                    }
                                                }
                                                min={
                                                    0
                                                }
                                                disabled={
                                                    fase ===
                                                    'listo'
                                                }
                                                etiqueta="numerador"
                                            />


                                            <div
                                                style={{
                                                    width:
                                                        80,

                                                    height:
                                                        4,

                                                    background:
                                                        INK,

                                                    borderRadius:
                                                        2
                                                }}
                                            />


                                            <Contador
                                                valor={
                                                    den
                                                }
                                                onCambio={
                                                    valor => {

                                                        setDen(
                                                            valor
                                                        );

                                                        setFeedback(
                                                            null
                                                        );
                                                    }
                                                }
                                                min={
                                                    1
                                                }
                                                disabled={
                                                    fase ===
                                                    'listo'
                                                }
                                                etiqueta="denominador"
                                            />

                                        </div>

                                    </div>


                                </RespuestaM153>
                            )
                        }

                    </PanelDerechoM153>


                </ZonaCentralM153>


                {/* ========================================================= */}
                {/* FEEDBACK                                                  */}
                {/* ========================================================= */}

                <p
                    style={{
                        minHeight:
                            24,

                        margin:
                            0,

                        padding:
                            '0 10px',

                        fontFamily:
                            'Nunito',

                        fontSize:
                            18,

                        fontWeight:
                            600,

                        textAlign:
                            'center',

                        color:

                            feedback

                                ? feedback.ok

                                    ? OK
                                    : MARK

                                : 'transparent'
                    }}
                    aria-live="polite"
                >
                    {
                        feedback

                            ? feedback.text

                            : '.'
                    }
                </p>


            </ContenidoM153>


            {/* ============================================================= */}
            {/* BOTTOM                                                        */}
            {/* ============================================================= */}

            <BottomM153>


                <BotoneraBottom
                    miniInstrucciones={
                        miniInstrucciones
                    }
                />


                <AvanzarBtn
                    disabled={
                        disable ||
                        fase ===
                        'listo'
                    }
                    onClick={
                        comprobar
                    }
                >

                    <AvanzarImg
                        src="/img/play.png"
                    />

                </AvanzarBtn>


            </BottomM153>


        </PantallaM153>
    );
};


export default M153;